/**
 * Extrae un mensaje legible de cualquier error capturado.
 * Útil dentro de catch blocks donde el error es de tipo unknown.
 */
export function errorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === 'object' && error !== null && 'message' in error) {
    const m = (error as { message?: unknown }).message;
    if (typeof m === 'string') return m;
  }
  if (typeof error === 'string') return error;
  return 'Unknown error';
}